import { Navigate } from "react-router-dom";
import { Heading } from "@chakra-ui/react";
import { useToken } from "../../../auth/hooks";
import { TableVehicle } from "../../components/TableVehicle";
import { useRedirect } from "./../../hooks/useNavigate";
import { PageHead } from "./../../../home/components/PageHead";

export const Vehicles = () => {
  const { addNewVehicle } = useRedirect();
  const [token] = useToken();

  if (token === null) {
    return <Navigate replace to="/login" />;
  }

  return (
    <PageHead
      breadCrumbs={<Heading>Автомобили</Heading>}
      onClick={addNewVehicle}
      linkLabel="Создать автомобиль"
    >
      <TableVehicle />
    </PageHead>
  );
};
